import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { useNavigate, useParams } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import {
  createPhase,
  createPrimary,
  deletePhase,
  getParents,
  getProject,
  getProperties,
} from "../../api/Primary";

const ViewPropertiesPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));

  const [properties, setProperties] = useState(null);

  useEffect(() => {
    propropertiesGet();
  }, []);

  const propropertiesGet = () => {
    getProperties(params.id, params.fromId).then((result) => {
      setProperties(result.data.Properties);
    });
  };

  const inputStyle = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: 0,
  };

  const labelStyle = {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
  };

  const labelDeleteStyle = {
    display: "inline-block",
    padding: "10px",
    backgroundColor: "red",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
    margin: "0px",
  };

  return (
    <div className="main-content">
      {properties === null ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          {properties.map((property, index) => (
            <div
              key={index}
              className="card-card"
              style={{ padding: "5px", margin: "10px" }}
            >
              <div className="card-info">
                <div>
                  <p className="line">
                    <span className="label">Property name:</span>{" "}
                    {property.name}
                  </p>
                  <p className="line">
                    <span className="label">Property Price:</span>{" "}
                    {property.price} EGP
                  </p>
                  <p className="line">
                    <span className="label">Property finishing:</span>{" "}
                    {property.finishing}
                  </p>
                </div>
              </div>
              <div className="card-actions">
                <button
                  className="action-btn accept-btn"
                  onClick={() => navigate(`/update_properties/${property._id}`)}
                >
                  View
                </button>
              </div>
            </div>
          ))}
          <div
            className="form-group"
            style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
          >
            <label
              htmlFor="addPaymentPlan"
              style={labelStyle}
              onClick={() => {
                navigate(`/add_property/${params.id}`);
              }}
            >
              Add Inventory
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewPropertiesPage;
